// 过期的活动页面处理
var expiredCampaign = {
    urlList:[
        'dellemc-solution.com/campaign/2019year-end',
        'dellemc-solution.com/campaign/xuanxingbao/2019year-end',
        'dellemc-solution.com/campaign/1212miaosha',
        'dellemc-solution.com/campaign/promotion20191111',
        'dellemc-solution.com/campaign/promotion201906',
        'dellemc-solution.com/campaign/storage_course',
        'dellemc-solution.com/campaign/channel_course',
        'dellemc-solution.com/campaign/2020OptiPlex',
        'dellemc-solution.com/campaign/200501survey',
        'dellemc-solution.com/campaign/20200618',
        'dellemc-solution.com/campaign/fy21q1_surveyform',
        'dellemc-solution.com/campaign/2020summer',
        'dellemc-solution.com/campaign/2020nationalday',
        'dellemc-solution.com/campaign/2020618',
        'dellemc-solution.com/campaign/2020Q4promotion',
        'dellemc-solution.com/campaign/20201111',
        'dellemc-solution.com/campaign/boxes',
        'dellemc-solution.com/campaign/2021618',
        'dellemc-solution.com/aihuishou/',
        'dellemc-solution.com/campaign/luckybox',
        'dellemc-solution.com/campaign/creatorpc',
        'dellemc-solution.com/campaign/newproducts',
        'dellemc-solution.com/campaign/precision-25th',
        'dellemc-solution.com/campaign/ccio/interview/2201100620101939',
        'dellemc-solution.com/campaign/olympic-canoeing',
        'dellemc-solution.com/campaign/2021newyear',
        'dellemc-solution.com/campaign/2020clearance',
        'dellemc-solution.com/campaign/powerstore_partner',
        'dellemc-solution.com/campaign/edm20200226',
        'dellemc-solution.com/campaign/topic20190919',
        'dellemc-solution.com/data-protection/',
        'dellemc-solution.com/powerprotect-software/',
        'dellemc-solution.com/powerprotect-appliances/',
        'dellemc-solution.com/data-protection/gdpi/',
        'dellemc-solution.com/dp4400',
        'dellemc-solution.com/campaign/salesstorage',
        'dellemc-solution.com/campaign/2023dtf-customform',
        'dellemc-solution.com/campaign/protect_earth',
        'dellemc-solution.com/campaign/2021server-upgrade',
        'dellemc-solution.com/campaign/server_special',
        'dellemc-solution.com/campaigns/escape-room/index.html',
        'dellemc-solution.com/5stor',
        'dellemc-solution.com/campaign/online_ad',
        'dellemc-solution.com/campaigns/casualty/',
        'dellemc-solution.com/campaign/eShop/Yida',
        'dellemc-solution.com/campaign/2020ccio',
        'dellemc-solution.com/campaign/financial',
        'dellemc-solution.com/campaign/5stor',
        'dellemc-solution.com/campaign/2020optiplex-ai',
        'dellemc-solution.com/campaign/2020wfa',
        'dellemc-solution.com/campaign/Digital-Givemefive',
        'dellemc-solution.com/campaign/Cloud',
        'dellemc-solution.com/campaign/ccgp',
        'dellemc-solution.com/premier/campaign',
        'dellemc-solution.com/campaign/new-products',
        'dellemc-solution.com/campaign/data-storage',
        'dellemc-solution.com/CSG',
        'dellemc-solution.com/campaign/business_pc',
    ],

    filter:function (urlList) {
        for(var i=0;urlList.length>i;i++){
            if(location.href.indexOf(urlList[i])>-1){
                msg.dialogDtf({
                    title:'活动已下线',
                    desc:'前往戴尔企采商城首页浏览更多资讯、促销活动',
                    linkText:'返回官网',
                    linkUrl: window.solution_host,
                    openNew: true
                });
            }
        }
    },

    init:function () {
        this.filter(this.urlList);
    }
};
expiredCampaign.init();
